<template>
  <SfTabs :open-tab="1" class="shop-setting">
    <SfTab title="Настройки магазина">
      <p class="message">
        Вы можете изменить данные в любой момент
      </p>
      <form class="form" @submit="updateInfo">
        <SfInput
          v-model="shop.name"
          name="name"
          label="Название"
          required
          class="form__element form__element--half"
        />
        <SfInput
          v-model="shop.phone"
          name="phone"
          label="Телефон"
          required
          class="form__element form__element--half form__element--half-even"
          v-mask="'+998#########'"
        />
        <SfInput
          v-model="shop.phone2"
          name="phone2"
          label="Телефон"
          class="form__element form__element--half form__element--half-even"
          v-mask="'+998#########'"
        />
        <SfTextarea
          style="width: 100%"
          v-model="shop.description"
          name="description"
          label="Описание"
          class="form__element"
        />
        <SfInput
          v-model="shop.address"
          name="address"
          label="Адрес"
          class="form__element"
        />
        <SfInput
          v-show="probeInputType != 'hidden'"
          v-model="shop.probe_583_price"
          name="probe_583_price"
          :type="probeInputType"
          label="583 проба"
          class="form__element"
          :class="{ 'has-text': shop.probe_583_price !== null && shop.probe_583_price !== '' }"
        />
        <SfInput
          v-show="probeInputType != 'hidden'"
          v-model="shop.probe_750_price"
          name="probe_750_price"
          :type="probeInputType"
          label="750 проба"
          class="form__element"
          :class="{ 'has-text': shop.probe_750_price !== null && shop.probe_750_price !== '' }"
        />
        <SfInput
          v-model="shop.work_time"
          name="work_time"
          label="Время работы"
          class="form__element"
        />
        <SfInput
          v-model="shop.map"
          name="map"
          label="Карта (Яндекс.Iframe)"
          class="form__element"
        />
        <div style="display: flex; justify-content: space-between; align-items: center; align-items: flex-start;">
          <img style="width: 10%;" :src="getImage(shop.logo)" alt="">  
          <SfInput
            type="file"
            name="logo"
            label="Лого"
            :required="shop.logo ? false : true"
            class="form__element"
            style="flex: 1; margin-left: 15px;"
          />
        </div>

        <div style="display: flex; justify-content: space-between; align-items: center; align-items: flex-start; width: 100%;">
          <img v-if="shop.banner_1" style="width: 10%; margin-right: 15px;" :src="getImage(shop.banner_1)" alt="">  
          <SfInput
            type="file"
            name="banner_1"
            label="Баннер 1"
            class="form__element"
            style="flex: 1;"
          />
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; align-items: flex-start; width: 100%;">
          <img v-if="shop.banner_mobile_1" style="width: 10%; margin-right: 15px;" :src="getImage(shop.banner_mobile_1)" alt="">  
          <SfInput
            type="file"
            name="banner_mobile_1"
            label="Баннер 1 (Мобильная версия)"
            class="form__element"
            style="flex: 1;"
          />
        </div>

        <div style="display: flex; justify-content: space-between; align-items: center; align-items: flex-start; width: 100%;">
          <img v-if="shop.banner_2" style="width: 10%; margin-right: 15px;" :src="getImage(shop.banner_2)" alt="">  
          <SfInput
            type="file"
            name="banner_2"
            label="Баннер 2"
            class="form__element"
            style="flex: 1;"
          />
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; align-items: flex-start; width: 100%;">
          <img v-if="shop.banner_mobile_2" style="width: 10%; margin-right: 15px;" :src="getImage(shop.banner_mobile_2)" alt="">  
          <SfInput
            type="file"
            name="banner_mobile_2"
            label="Баннер 2 (Мобильная версия)"
            class="form__element"
            style="flex: 1;"
          />
        </div>

        <div style="display: flex; justify-content: space-between; align-items: center; align-items: flex-start; width: 100%;">
          <img v-if="shop.banner_3" style="width: 10%; margin-right: 15px;" :src="getImage(shop.banner_3)" alt="">  
          <SfInput
            type="file"
            name="banner_3"
            label="Баннер 3"
            class="form__element"
            style="flex: 1;"
          />
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; align-items: flex-start; width: 100%;">
          <img v-if="shop.banner_mobile_3" style="width: 10%; margin-right: 15px;" :src="getImage(shop.banner_mobile_3)" alt="">  
          <SfInput
            type="file"
            name="banner_mobile_3"
            label="Баннер 3 (Мобильная версия)"
            class="form__element"
            style="flex: 1;"
          />
        </div>
        <div style="width: 100%; margin-bottom: 30px;">
          <SfCheckbox
            v-model="shop.delivery"
            name="delivery"
            label="Есть доставка"
            :value="1"
          />  
        </div>
        
        <SfButton class="form__button classic-button"
          >Сохранить
        </SfButton>
      </form>
      <p class="notice">
        Используя наш сайт вы соглашаетесь с нашей
        <router-link :to="{ name: 'page', params: { slug: 'privacy' } }">
          политикой конфиденциальности и обработки данных.
        </router-link>
      </p>
    </SfTab>
  </SfTabs>
</template>
<script>
import { SfTabs, SfInput, SfButton, SfTextarea, SfCheckbox } from "@storefront-ui/vue";
import apiRequest from '../../shared/apiRequest'

export default {
  name: "PersonalDetails",
  components: {
    SfTabs,
    SfInput,
    SfButton,
    SfTextarea,
    SfCheckbox
  },
  props: {
    account: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      shop: {
        name: "",
        phone: "",
        phone2: "",
        description: "",
        address: "",
        work_time: "",
        delivery: false,
        map: "",
        probe_583_price: 0,
        probe_750_price: 0
      }
    };
  },
  watch: {
    account: {
      handler(value) {
        this.name = value.name;
        this.phone = value.phone;
        this.email = value.email;
      },
      immediate: true,
    },
  },

  mounted() {
    this.getShopInfo()
  },
  computed: {
    probeInputType() {
      return this.shop.id === 22 ? 'number' : 'hidden'
    }
  },
  methods: {
    getShopInfo() {
      apiRequest.get(`/users/${this.account.id}/shop`, {
      })
        .then((result) => {
          this.shop = {...result.data, delivery: result.data.delivery == true }
        })
    },
    updateInfo(e) {
      e.preventDefault();
      console.log(e.target)

      var formData = new FormData(e.target);

      if(this.shop.delivery == false) {
        formData.append('delivery', 0);
      }

      apiRequest.post(`/users/${this.account.id}/shop`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((result) => {
          this.shop = {...result.data, delivery: result.data.delivery == true }
          alert('Успешно обновлено');
        })
    },
    getImage(image) {
      return `${process.env.VUE_APP_STORAGE}/${image}`
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/vue/styles";
.form {
  @include for-desktop {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  &__element {
    margin: 0 0 var(--spacer-lg) 0;
    @include for-desktop {
      flex: 0 0 100%;
    }
    &--half {
      @include for-desktop {
        flex: 1 1 50%;
      }
      &-even {
        @include for-desktop {
          padding: 0 0 0 var(--spacer-lg);
        }
      }
    }
    textarea {
      width: 100%;
    }
  }
  &__button {
    --button-width: 100%;
    @include for-desktop {
      --button-width: 17.5rem;
    }
  }
}
.message {
  margin: 0 0 var(--spacer-xl) 0;
  color: var(--c-dark-variant);
}
.notice {
  margin: var(--spacer-base) 0 0 0;
  font-size: var(--font-size--sm);
}
a {
  color: var(--c-primary);
  text-decoration: none;
  &:hover {
    color: var(--c-text);
  }
}
</style>

<style lang="scss">
.shop-setting {
  .form__element {
    textarea {
      width: 100%;
    }
  }
}
</style>